import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import StatsEliteLogo from '../brand/StatsEliteLogo';
import AuthSliderPanel from './AuthSliderPanel';
import '../../components/admin/Admin.css';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await login(email, password);

        if (result.success) {
            navigate('/admin/dashboard');
        } else {
            setError(result.message);
            setLoading(false);
        }
    };

    return (
        <div className="auth-shell">
            <AuthSliderPanel
                eyebrow="Admin Portal"
                title="Manage insight, content, and client conversations in one place."
                text="Stats Elite brings data consulting, MERL fieldwork, and training operations into a focused admin workspace."
            />
            <div className="auth-panel">
                <div className="auth-card">
                {/* Logo & Title */}
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '14px'
                    }}>
                        <StatsEliteLogo markSize={58} wordSize={22} gap={10} />
                    </div>
                    <p style={{
                        fontSize: '14px',
                        color: '#666666',
                        fontWeight: '400',
                        margin: '0'
                    }}>
                        Data Consulting Admin Panel
                    </p>
                </div>

                {error && (
                    <div style={{
                        background: '#fee2e2',
                        color: '#991b1b',
                        padding: '12px 16px',
                        borderRadius: '0',
                        fontSize: '14px',
                        marginBottom: '24px',
                        textAlign: 'center',
                        border: '1px solid #fecaca'
                    }}>
                        <i className="fa fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#222222',
                            marginBottom: '8px',
                            letterSpacing: '0.3px'
                        }}>
                            Email Address
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '2px solid #e2e8f0',
                                borderRadius: '0',
                                fontSize: '14px',
                                fontFamily: '"Poppins", sans-serif',
                                boxSizing: 'border-box',
                                outline: 'none',
                                transition: 'all 0.3s ease'
                            }}
                            placeholder="admin@stateelite.com"
                            required
                            onFocus={(e) => {
                                e.target.style.borderColor = '#62B6E8';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '28px' }}>
                        <label style={{
                            display: 'block',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#222222',
                            marginBottom: '8px',
                            letterSpacing: '0.3px'
                        }}>
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '2px solid #e2e8f0',
                                borderRadius: '0',
                                fontSize: '14px',
                                fontFamily: '"Poppins", sans-serif',
                                boxSizing: 'border-box',
                                outline: 'none',
                                transition: 'all 0.3s ease'
                            }}
                            placeholder="Enter your password"
                            required
                            onFocus={(e) => {
                                e.target.style.borderColor = '#62B6E8';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                            }}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            padding: '14px',
                            background: loading ? '#9ca3af' : '#62B6E8',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '0',
                            fontSize: '15px',
                            fontWeight: '600',
                            fontFamily: '"Poppins", sans-serif',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.7 : 1,
                            transition: 'all 0.3s ease',
                            letterSpacing: '0.3px'
                        }}
                        onMouseEnter={(e) => {
                            if (!loading) {
                                e.target.style.background = '#2F7FAE';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) {
                                e.target.style.background = '#62B6E8';
                            }
                        }}
                    >
                        {loading ? (
                            <>
                                <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                                Signing in...
                            </>
                        ) : 'Sign In'}
                    </button>
                </form>

                <div style={{
                    marginTop: '32px',
                    paddingTop: '24px',
                    borderTop: '1px solid #e2e8f0',
                    textAlign: 'center'
                }}>
                    <p style={{
                        fontSize: '13px',
                        color: '#666666',
                        marginBottom: '8px',
                        fontWeight: '500'
                    }}>
                        Default Credentials
                    </p>
                    <div style={{
                        fontSize: '13px',
                        color: '#62B6E8',
                        fontWeight: '600',
                        background: '#e3f2fd',
                        padding: '10px 16px',
                        borderRadius: '0',
                        display: 'inline-block'
                    }}>
                        admin@stateelite.com / admin123
                    </div>
                </div>

                <div style={{
                    marginTop: '24px',
                    textAlign: 'center'
                }}>
                    <a
                        href="/"
                        style={{
                            fontSize: '13px',
                            color: '#666666',
                            textDecoration: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'color 0.3s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.color = '#62B6E8'}
                        onMouseLeave={(e) => e.target.style.color = '#666666'}
                    >
                        <i className="fa fa-arrow-left"></i>
                        Back to Website
                    </a>
                </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
